import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
@Injectable()
export class Authentication {
    constructor() { }
    login() {
        //window.location.href = "https://login.microsoftonline.com/" + environment.tenantId + "/oauth2/v2.0/authorize?client_id=" + environment.clientId + "&response_type=id_token & redirect_uri=" + environment.redirectUrl+'&scope=openid&state=12345&nonce=12345';
    }
}

